import React from 'react';

interface PDFViewerProps {
  pdfUrl: string;
  title?: string;
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
}

const PDFViewer: React.FC<PDFViewerProps> = ({ pdfUrl, title, showModal, setShowModal }) => {

  return (
    <div>
      <div
        className={`${
          showModal ? "block" : "hidden"
        } fixed inset-0 z-50  `}
        style={{ backdropFilter: "blur(2px)" }}
      >
        <div
          className={`flex items-center justify-center p-4 min-h-screen w-full mx-auto`}
        >
          <div className={`relative bg-[#FFF] rounded-lg shadow w-full`}>
            <div className="relative bg-[#FFF]  shadow dark:bg-gray-700">
              {title && (
                <div className="flex items-center justify-between p-4 md:p-5  rounded-t ">
                  <h3
                    className={`text-xl font-semibold text-black`}
                  >
                    {title}
                  </h3>
                  <button
                    onClick={() => setShowModal(false)}
                    type="button"
                    className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                  >
                    <svg
                      className="w-3 h-3"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 14 14"
                    >
                      <path
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                      />
                    </svg>
                  </button>
                </div>
              )}
              <div className="p-4 pt-0 md:p-5 space-y-4">
                <div style={{ width: '100%', height: '80vh' }}>
                  <iframe
                    src={pdfUrl}
                    width="100%"
                    height="100%"
                    style={{ border: 'none' }}
                    title="PDF Viewer"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PDFViewer;
